import { makeStyles } from '@material-ui/styles';
import React, { FunctionComponent } from 'react';
import { IErrorMessageJsonData } from './RequestControl';

interface ITableDisplayCellProps {
	column: string,
	errorMessages: IErrorMessageJsonData[],
}

const useStyles = makeStyles((theme) => ({
	ul: {
		color: "red",
	},
	li: {

	}
}));

export const TableDisplayCell: FunctionComponent<ITableDisplayCellProps> = (props) => 
{
	const classes = useStyles();

	var errors = props.errorMessages?.filter(x => x.column === props.column).map((x, i) => <li key={i} className={classes.li}>{x.errorMessage}</li>);

	return <span>
		{props.children}
		{errors && errors.length > 0 && <ul className={classes.ul}>
			{errors}
		</ul>}
	</span>
}